import { render, staticRenderFns } from "./RecruitmentContactList.vue?vue&type=template&id=6daa57e4&scoped=true&lang=pug"
import script from "./RecruitmentContactList.vue?vue&type=script&lang=ts"
export * from "./RecruitmentContactList.vue?vue&type=script&lang=ts"
import style0 from "./RecruitmentContactList.vue?vue&type=style&index=0&id=6daa57e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa57e4",
  null
  
)

export default component.exports